import { MockRoute } from '../mockBackend';
import { PreviewDataset } from '../../preview.types';

// Company org chart for the Succession Planning preview: GET /Organization/Chart.
// OrgUserList (src/data/users/OrgUserList.ts) reads `data.employees` as a map; each entry →
// new OrgChartEmployee(employee, jobTitle, reportsTo?.employeeId ?? reportsToId). A null
// reportsToId makes that node a root (parentId "org-root-job"). The node drill-in reuses the
// already-mocked /Teams/employees/:id + /Profile, so no extra endpoint is needed here.
//
// Synthetic reporting lines (keyed by employeeId; absent = top of tree). Kept here because the org
// chart is the only consumer — not worth a field on every employee record. e13 (Safety & Compliance
// Officer) is the root; captains lead their crews; engineers/ground staff report up.
const REPORTS_TO: Record<string, string> = {
  e01: 'e13',
  e02: 'e13',
  e08: 'e13',
  e10: 'e13',
  e12: 'e13',
  e03: 'e01',
  e05: 'e01',
  e14: 'e01',
  e04: 'e02',
  e06: 'e02',
  e07: 'e02',
  e09: 'e08',
  e11: 'e10',
};

function buildOrgChart(dataset: PreviewDataset) {
  const jobs = new Map(dataset.jobs.map((j) => [j.id, j]));
  const employees: Record<string, unknown> = {};
  dataset.employees.forEach((e) => {
    employees[e.id] = {
      employee: {
        employeeId: e.id,
        firstName: e.firstName,
        lastName: e.lastName,
        fullName: `${e.firstName} ${e.lastName}`,
        hasProfilePicture: false, // initials only — never request a real avatar (fail-closed)
      },
      jobTitle: jobs.get(e.jobId ?? '')?.title ?? '',
      reportsToId: REPORTS_TO[e.id] ?? null,
    };
  });
  return { employees };
}

export const companyRoutes: MockRoute[] = [
  { pattern: '/Organization/Chart', build: ({ dataset }) => buildOrgChart(dataset) },
];
